<template>
    <div id="top-anchor" class="normal-container py-5">
        <div class="row">
            <div class="col-lg-10 offset-lg-1">
                <div class="row align-items-end">
                    <div class="col-md-5 text-center mb-5 mx-auto">
                        <div class="login-page py-5 mb-5">
                            <form @submit.prevent="sendPasswordResetEmail()">
                                <h3>Password Recovery Page</h3>

                                <p>
                                    <small
                                        >Please enter your email address and
                                        click 'Recover Password.' A new password
                                        will be emailed to you.</small
                                    >
                                </p>

                                <div class="form-group">
                                    <div class="input-group mb-3">
                                        <div class="input-group-prepend">
                                            <span
                                                id="basic-addon1"
                                                class="input-group-text"
                                                ><img
                                                    src="@assets/images/icon-username.png"
                                                    alt=""
                                            /></span>
                                        </div>
                                        <input
                                            v-model="email"
                                            required
                                            type="email"
                                            :class="[
                                                arrayExists(
                                                    validationErrors.email
                                                )
                                                    ? 'is-invalid'
                                                    : '',
                                                'form-control',
                                            ]"
                                            placeholder="Email Address"
                                            aria-label="Email Address"
                                            aria-describedby="basic-addon1"
                                        />

                                        <div
                                            v-for="(
                                                err, idx
                                            ) in validationErrors.email"
                                            :key="idx"
                                            class="invalid-feedback alert alert-danger mt-2 mb-0"
                                        >
                                            {{ err }}
                                        </div>
                                    </div>
                                </div>

                                <div class="row text-center">
                                    <div class="col">
                                        <router-link
                                            :to="{
                                                name:
                                                    addMessagingRouting +
                                                    'auth.login',
                                                hash: '#top-anchor',
                                            }"
                                        >
                                            Cancel Password Recovery
                                        </router-link>
                                    </div>
                                </div>

                                <div class="row text-center">
                                    <div class="col mt-3">
                                        <button
                                            type="submit"
                                            :disabled="disableSubmit"
                                            class="btn btn-primary btn-lg"
                                        >
                                            Recover Password
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/lib/api';
import { errorHandling } from '@/mixins/error-handling';
import { notify } from '@/mixins/notify';
import { routing } from '@/mixins/routing';

export default {
    mixins: [errorHandling, notify, routing],
    data() {
        return {
            disableSubmit: false,
            email: '',
        };
    },
    methods: {
        sendPasswordResetEmail() {
            this.validationErrors = {};
            this.disableSubmit = true;
            const data = { email: this.email };

            if (this.isMessagingApp) {
                data.is_iwebvisit_touch = true;
            }

            return api.v2.auth
                .email(data)
                .then((resp) => {
                    this.$swal.fire('Success!', resp.data.message, 'success');
                    this.$router.push({
                        name: this.addMessagingRouting + 'index',
                    });
                })
                .catch((err) => this.notify(this.handleError(err)));
        },
    },
};
</script>
